const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/**
 * Open the Google OAuth consent screen in a new window.
 * After consent, Google redirects back to our callback which creates the mailbox
 * and redirects the user back to the app.
 */
export type GmailTier = 'readonly' | 'modify' | 'full';

export function connectGmail(opts?: {
  category?: 'personal' | 'business';
  businessId?: string | null;
  displayName?: string;
  tier?: GmailTier;
}) {
  const params = new URLSearchParams();
  if (opts?.category) params.set('category', opts.category);
  if (opts?.businessId) params.set('businessId', opts.businessId);
  if (opts?.displayName) params.set('displayName', opts.displayName);
  if (opts?.tier) params.set('tier', opts.tier);
  const qs = params.toString();
  // Direct browser navigation — the backend redirects to Google
  window.location.href = `${API_BASE_URL}/oauth/gmail/auth${qs ? `?${qs}` : ''}`;
}